<!-- 打包订单列表 -->
<template>
  <div class="home">
    <van-nav-bar
      :title="$t('PlaceOrderDetail.orderList')"
      fixed
      left-arrow
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <div class="main">
      <van-cell
        v-for="item in orderList"
        :key="item.id"
        :title="$t('Home.packNumber') + `： ${item.ticket}`"
        :label="item.created_at"
        is-link
        @click="$router.push('/PackOrderDetail/' + item.id)"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderList: []
    };
  },
  mounted() {
    this.orderList = JSON.parse(sessionStorage.getItem("orderList"));
  },
  watch: {
    // 监听路由对象，一旦变化，执行该函数
    $route: function(to, from) {
      this.orderList = JSON.parse(sessionStorage.getItem("orderList"));
    }
  },
  methods: {}
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
.okIcon {
  vertical-align: middle;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #fff;
}
.main {
  padding-top: 46px;
  width: 100%;
  height: 100%;
  background-color: #f3f5f7;
}
</style>



// WEBPACK FOOTER //
// src/packDishes/PackOrderList.vue